module.exports = "/_next/static/images/credit-2-54323289423cf2b9cc8ef7fe642df82b.png";